import { render } from "./DField.vue?vue&type=template&id=381d0630&ts=true"
import script from "./DField.vue?vue&type=script&lang=ts"
export * from "./DField.vue?vue&type=script&lang=ts"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\Atlanta-FE-Git-189PRE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__